import { combineReducers } from 'redux';

import auth from '@/redux/auth/reducer';
import user from '@/redux/user/reducer';
import campaign from '@/redux/campaign/reducer';

export default combineReducers({ auth, user, campaign });
